module.exports = __webpack_public_path__ + "static/media/clients.5cae1646.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/clients.jpg
// module id = 102
// module chunks = 0